import { useTheme } from "@mui/material/styles";

export default useTheme;
